import { Link } from "react-router-dom";
import { CalendarDays, Clock, ArrowRight } from "lucide-react";
import { resolveLinked, formatFrDate } from "../../lib/linked";
import { MapsWaze } from "./MapsWaze";
import { effectiveState } from "../../lib/publish";

// Auto action block shown at the END of a news article.
// Info is pulled LIVE from the linked content (single source of truth) when linked,
// otherwise falls back to the article's own fields. Fully toggleable per article.
export const NewsActionBlock = ({ item = {}, content = {} }) => {
  if (!item.actionBlockEnabled) return null;

  const linked = resolveLinked(content, item.linkedType, item.linkedId);

  const dateText = (linked && linked.dateText) || formatFrDate(item.date) || item.date || "";
  const timeText = (linked && linked.timeText) || item.actionTime || "";
  const locationName = (linked && linked.locationName) || item.locationName || "";
  const address = (linked && linked.address) || item.address || "";

  // A linked content that is "coming" keeps the action locked; a past article/content closes it.
  const locked = linked && linked.target && effectiveState(linked.target) === "coming";
  const past = effectiveState(item) === "past" || (linked && linked.target && effectiveState(linked.target) === "past");
  const disabled = locked || past;
  const btnLabel = item.actionBlockLabel || (linked && linked.ctaLabel) || "En savoir plus";
  const href = (linked && linked.href) || item.actionBlockUrl || "";
  const isExternal = /^https?:\/\//.test(href);

  const hasInfo = dateText || timeText || locationName || address;
  if (!hasInfo && !href) return null;

  const btnCls = `inline-flex items-center justify-center gap-2 px-7 py-3.5 rounded-full text-[12px] tracking-[0.12em] uppercase font-semibold transition-colors ${disabled ? "bg-white/5 text-white/40 border border-white/10 cursor-not-allowed" : "bg-electric text-black hover:bg-white"}`;

  return (
    <div className="mt-12 rounded-2xl border border-electric/25 bg-gradient-to-br from-surface/70 to-[#050505] p-6 md:p-8" data-testid="news-action-block">
      <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-5">
        <div className="space-y-2.5">
          {dateText && <div className="flex items-center gap-2 text-white" data-testid="news-action-date"><CalendarDays size={17} className="text-electric" /> <span className="text-lg">{dateText}</span></div>}
          {timeText && <div className="flex items-center gap-2 text-white/85" data-testid="news-action-time"><Clock size={15} className="text-electric" /> {timeText}</div>}
          {(locationName || address) && (
            <div data-testid="news-action-location">
              {address ? <MapsWaze name={locationName} address={address} testid="news-action-maps" />
                : <span className="text-white/85">{locationName}</span>}
            </div>
          )}
        </div>
        {href && (
          disabled
            ? <span className={btnCls} data-testid="news-action-btn">{past ? "Terminé" : "Bientôt disponible"}</span>
            : isExternal
              ? <a href={href} target="_blank" rel="noreferrer" className={btnCls} data-testid="news-action-btn">{btnLabel} <ArrowRight size={15} /></a>
              : <Link to={href} className={btnCls} data-testid="news-action-btn">{btnLabel} <ArrowRight size={15} /></Link>
        )}
      </div>
    </div>
  );
};
